/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Event_TemplateInputs */

const en_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add To Templates`)
};

const fr_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter aux modèles`)
};

const de_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Vorlagen hinzufügen`)
};

const it_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi ai modelli`)
};

const ru_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить в шаблоны`)
};

const es_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar a plantillas`)
};

const zh_cn2_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加到模板`)
};

const ja_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレートに追加`)
};

const hi_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेम्प्लेट में जोड़ें`)
};

const pt_pt2_context_menu_event_template = /** @type {(inputs: Context_Menu_Event_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar aos modelos`)
};

/**
* | output |
* | --- |
* | "Add To Templates" |
*
* @param {Context_Menu_Event_TemplateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_event_template = /** @type {((inputs?: Context_Menu_Event_TemplateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Event_TemplateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_event_template(inputs)
	if (locale === "de") return de_context_menu_event_template(inputs)
	if (locale === "it") return it_context_menu_event_template(inputs)
	if (locale === "ru") return ru_context_menu_event_template(inputs)
	if (locale === "es") return es_context_menu_event_template(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_event_template(inputs)
	if (locale === "ja") return ja_context_menu_event_template(inputs)
	if (locale === "hi") return hi_context_menu_event_template(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_event_template(inputs)
	return en_context_menu_event_template(inputs)
});